export default __webpack_public_path__ + "static/media/no_files_mobile.b03e4726.png";